<div class="login-screen">
    <div class="separ-div">
        <div class="inner-separ">
            <img src="assets/logo_color.png" />
            <p>
                System do optymalizacji i dynamicznego zarządzania asortymentem w małych i średnich
                sieciach handlowych realizowany w oparciu o innowacyjne rozwiązania.
            </p>
            <form action="/">
                <button mat-button (click)="login()" type="submit">
                    Zaloguj się
                </button>
            </form>
        </div>
        <div class="footer-ue">
            <div fxLayout="row" fxLayoutAlign="center">
                <img src="../assets/FE_POPW_poziom_pl-1_rgb.png" />
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <p class="block-disclaimer">
                    Projekt "Shelfy - system do optymalizacji i
                    dynamicznego zarządzania asortymentem w małych i średnich sieciach
                    handlowych" jest współfinansowany ze środków Unii
                    Europejskiej w ramach Europejskiego Funduszu Rozwoju
                    Regionalnego w ramach osi priorytetowej I: Przedsiębiorcza
                    Polska Wschodnia, działania 1.1 Platformy startowe dla
                    nowych pomysłów, Poddziałanie 1.1.2 Rozwój startupów w
                    Polsce Wschodniej.
                </p>
            </div>
        </div>
    </div>
</div>
